export const AUTH_NAMESPACE = 'auth'
